import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
export function SolutionReveal() {
  return <section className="py-20 px-4 bg-dark-card relative overflow-hidden" data-id="element-243" data-mp="1d0cpnrg32dfu">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-px bg-gradient-to-r from-transparent via-gold to-transparent opacity-50" data-id="element-244" data-mp="1rqbirfss6yog"></div>

      <div className="max-w-4xl mx-auto text-center" data-id="element-245" data-mp="1mtbe99bky3zg">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-246" data-mp="z25yeu5n3bp5">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-gold/10 text-gold mb-5" data-id="element-247" data-mp="17zq4cgeg5w63">
            <span className="text-2xl" data-id="element-248" data-mp="2jgy8d0l6la9q">🏆</span>
          </div>
          <h2 className="text-2xl md:text-4xl font-serif font-bold mb-4" data-id="element-249" data-mp="2jjaxpyt9qmwt">
            El sistema más completo de metodología de la investigación para el
            aula de habla hispana
          </h2>
          <h3 className="text-xl font-bold text-gold-gradient mb-3" data-id="element-250" data-mp="2bxtdywk3z7yb">
            Mega Pack Metodología de la Investigación 360
          </h3>
          <p className="text-base md:text-lg text-gray-300 mb-10" data-id="element-251" data-mp="2kvvk1qip8qsg">
            6 tomos · 4 bonos estratégicos · Todo listo para usar desde hoy.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 text-left" data-id="element-252" data-mp="1t57kgiwobtgw">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="space-y-3 bg-black p-6 rounded-2xl border border-dark-border" data-id="element-253" data-mp="1t72aucqpsdsd">
            <div className="flex items-start gap-3" data-id="element-254" data-mp="19i096tytv471">
              <X className="text-red-500 shrink-0 mt-1" size={18} data-id="element-255" data-mp="19f5nkz42vdc1" />
              <p className="text-gray-400 text-sm" data-id="element-256" data-mp="1ef0cix4alsug">
                No es teoría copiada de un manual.
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-257" data-mp="2how4y5mum3xx">
              <X className="text-red-500 shrink-0 mt-1" size={18} data-id="element-258" data-mp="2crcpx3ibtn4x" />
              <p className="text-gray-400 text-sm" data-id="element-259" data-mp="2qjaponq5e6of">
                No es una colección de actividades sueltas.
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-260" data-mp="2mih44106h3yp">
              <X className="text-red-500 shrink-0 mt-1" size={18} data-id="element-261" data-mp="1yruva7icnfnn" />
              <p className="text-gray-400 text-sm" data-id="element-262" data-mp="1yu7o5fpnbafh">
                No es material que tengas que adaptar entero.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-gold/10 p-6 rounded-2xl border border-gold/30 relative overflow-hidden" data-id="element-263" data-mp="27um9gf2m0piz">
            <div className="absolute top-0 right-0 w-32 h-32 bg-gold/20 blur-3xl rounded-full" data-id="element-264" data-mp="3mpvxgerwynmj"></div>
            <div className="flex items-start gap-3 relative z-10" data-id="element-265" data-mp="3qrza36qbjy9e">
              <Check className="text-gold shrink-0 mt-1" size={20} data-id="element-266" data-mp="3cry2z9jgnulh" />
              <p className="text-white font-medium text-base leading-relaxed" data-id="element-267" data-mp="3ctslkh79fame">
                Es un sistema para que entres al aula con confianza y dictes
                clases que de verdad enseñen a investigar.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}